<template>
    <div class="bubble-actions">
        <div class="page-header">
            <div class="title">{{ $t("message.bubbleOpenableMenu") }}</div>
            <div class="subtitle">
                {{ $t("settings.bubbleActionsSubtitles") }}
            </div>
        </div>
        <section>
            <div class="fields">
                <div class="header-fields">
                    <FeatureItem
                        v-model="isAlwaysActive"
                        :title="$t('message.isAlwaysActive')"
                        :description="$t('message.isAlwaysActiveDesc')"
                        icon="fab-menu"
                        style="width: 100%"
                    />
                </div>
                <div class="header-fields">
                    <FeatureItem
                        v-model="isFabsActive"
                        :title="$t('message.isFabsActive')"
                        :description="$t('message.vtippyIsFabsActive')"
                        icon="DropdownMenuIcon"
                    />
                    <FeatureItem
                        v-model="isFabsAsIcon"
                        :title="$t('settings.isFabsAsIcon')"
                        :description="$t('message.vtippyIsFabsAsIcon')"
                        icon="AddIcon"
                    />
                </div>
            </div>
            <a-divider />
            <div class="fab-content">
                <FabEditor :update-settings="updateSettings" />
            </div>
        </section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../../utils/log2";
import * as _ from "lodash";
import FAB from "../../../../../components/FAB.vue";
import BubblePreview from "../../../../../components/fast-initialize/BubblePreview.vue";
import FeatureItem from "../../../Settings/components/FeatureItem.vue";
import FabEditor from "../../../Settings/components/FabEditor.vue";
import FabPreview from "../../../Settings/components/FabPreview.vue";

const log = log2("Settings/BubbleActions");
export default {
    name: "BubbleActions",
    components: {
        FabPreview,
        FAB,
        BubblePreview,
        FeatureItem,
        FabEditor,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            fabEnabledFromLS: localStorage.fabEnabled === "true",
            enabledFabs: [],
            showPreview: false,
        };
    },

    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            bubbleIcon() {
                let { customIcon } = this.settings.bubble;
                if (this.newIcon || customIcon) {
                    let asset = this.newIcon || customIcon;
                    return asset.v2Format && asset.cdnUrl
                        ? asset.cdnUrl
                        : `https://static.supsis.live/${asset.path + asset._id}${asset.ext ? "." + asset.ext : ""}`;
                }
                return undefined;
            },
        }),
        isFabsActive: {
            get() {
                return _.get(this.settings, "fab.isFabsActive");
            },
            set(value) {
                this.updateSettings("fab.isFabsActive", value);
            },
        },
        isFabsAsIcon: {
            get() {
                return _.get(this.settings, "fab.isFabsAsIcon");
            },
            set(value) {
                this.updateSettings("fab.isFabsAsIcon", value);
            },
        },
        isAlwaysActive: {
            get() {
                return _.get(this.settings, "fab.isAlwaysActive");
            },
            set(value) {
                this.updateSettings("fab.isAlwaysActive", value);
            },
        },
    },
    methods: {},
    mounted() {
    },
    watch: {},
};
</script>

<style lang="scss">
.bubble-actions {
    .header-fields {
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .fab-content {
        display: flex;
        flex-direction: row;
        gap: 10px;

        .left {
            border-right: 1px solid var(--color-border-default);
            padding-right: 20px;
            width: 80%;
        }

        .right {
            justify-content: center;
            display: flex;
            align-items: center;
        }
    }

    .feature-fab {
        background: transparent !important;
        border: none !important;
    }

    .icon {
        display: flex;
        justify-content: center;
        gap: 20px;
        font-weight: bold;
    }

    .btnColor {
        border-color: var(--color-bg-primary-default) !important;
        color: var(--color-bg-primary-default) !important;
    }
}
</style>
